<div [ngClass]="pageConfig?.isUsingHtmlStructure ? 'd-flex' : ''">
  @if (widgetConfig && (this.overlayActive === true || this.overlay === false)) {
  <button class="pointer-events-none back-widget-button webkit-tap-highlight-color-transparent d-flex"
    [ngStyle]="!isAllowedGlobalStyling ? contentStyle : {}" [ngClass]="[
      pageConfig?.isUsingHtmlStructure ? (!isAllowedGlobalStyling ? 'w-100' : '') : 'position-absolute-fill',
      isAllowedGlobalStyling ? globalStylingClass + ' buttonText' : '',
      isAllowedGlobalStyling && icon ? 'with-icon' : ''
    ]" (click)="handlePrevAction()" [disabled]="false">
    @if (icon !== null && icon !== '') {
    <mat-icon [svgIcon]="icon" [ngStyle]="iconSize" [class.icon]="!isAllowedGlobalStyling"></mat-icon>
    }
    <div [innerHTML]="renderedContent | safeHtml"></div>
  </button>
  }
</div>